import { connect } from 'react-redux'

import { doFetchJiraCloudSites } from 'ducks/integrations/jiraCloud'

import LinkJiraCloudCardsView from './view'

export default connect(null, {
  doFetchJiraCloudSites,
})(LinkJiraCloudCardsView)
